import styled from '@emotion/styled';
import { NavLink } from 'react-router-dom';

import { navAsset, sixPack, navItems } from './navConfig';

/* ------------------------------------------------------------------ */
/* Layout                                                              */
/* ------------------------------------------------------------------ */

const Sidebar = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 16px;
`;

const NavTop = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const NavHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  padding: 0 4px;
`;

const Logo = styled.img`
  width: 87px;
  height: 36px;
`;

const IconButton = styled.button`
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: rgba(17, 17, 0, 0.04);
  }
`;

const SixPack = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const SixPackItem = styled(NavLink)`
  width: 108px;
  height: 62px;
  box-sizing: border-box;
  text-decoration: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 16px 0;
  border-radius: 16px;
  border: 1px solid rgba(17, 17, 0, 0.04);
  background: #f8f7f7;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.06);
  transition:
    background 0.15s ease,
    box-shadow 0.15s ease;

  &:hover {
    background: #ffffff;
  }

  &.active {
    background: #ffffff;
    border-color: #111100;
    box-shadow: 0 0 20px 4px rgba(0, 0, 0, 0.06);
  }
`;

const SixPackLabel = styled.span`
  font-size: 12px;
  line-height: 17.8px;
  font-weight: 400;
  color: #111100;
`;

const NavSection = styled.nav`
  flex: 1 0 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const NavRow = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 36px;
  width: 100%;
  padding: 0 12px;
  border-radius: 10px;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: rgba(17, 17, 0, 0.04);
  }

  &.active {
    background: rgba(17, 17, 0, 0.04);
  }
`;

const IconFrame = styled.span`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const NavLabel = styled.span`
  flex: 1 0 0;
  min-width: 0;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: #111100;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

/* ------------------------------------------------------------------ */
/* Component                                                           */
/* ------------------------------------------------------------------ */

export function SideNav() {
  return (
    <Sidebar data-testid="nav_sidebar">
      <NavTop>
        <NavHeader>
          <Logo src={navAsset('logo-wordmark')} alt="Flodesk" />
          <IconButton type="button" aria-label="Collapse sidebar">
            <img src={navAsset('sidebar-open')} alt="" width={15} height={16} />
          </IconButton>
        </NavHeader>

        <SixPack>
          {sixPack.map(item => (
            <SixPackItem key={item.key} to={item.to} end={item.end}>
              <img src={navAsset(item.icon)} alt="" width={item.w} height={item.h} />
              <SixPackLabel>{item.label}</SixPackLabel>
            </SixPackItem>
          ))}
        </SixPack>
      </NavTop>

      <NavSection>
        {navItems.map(item => (
          <NavRow key={item.key} to={item.to} end={item.end}>
            <IconFrame>
              <img src={navAsset(item.icon)} alt="" width={item.w} height={item.h} />
            </IconFrame>
            <NavLabel>{item.label}</NavLabel>
          </NavRow>
        ))}
      </NavSection>
    </Sidebar>
  );
}
